import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/reallocateAll/nonBillable`;

export const ROUTE: RouteDefinition = `${baseRoute}/reallocateAll/nonBillable`;

export const URL = (): RouteDefinition => `${baseRoute}/reallocateAll/nonBillable`;
